module.exports = __webpack_public_path__ + "static/media/equalicare-img08.9d9ce92e.png";